/* ─── CONFIG ───────────────────────────────────────────────────────────
   Each stage maps to the product HANDLE for the kit, and the handle for the
   kit bundled with the Anti Dandruff Shampoo. Clicking ORDER NOW adds
   `handle`; the "+ Anti Dandruff Shampoo" button adds `addonHandle`.

   The handle is the slug at the end of a product's PUBLIC url:
     https://lakshmikrishnanaturals.com/products/THIS-PART
   The values below are best guesses from the product names — open each
   product's public page and confirm the slug matches; fix any that differ.
   (Product ids are kept in comments only for reference.)
──────────────────────────────────────────────────────────────────────── */
  var CFG = {
    whatsapp: '917540042668',
    waMsg: 'Hi! I need a hair consultation.',
    kits: {
      1: {  /* Mild Hair Fall Recovery Kit  (product 8600830214317 / addon 8601103204525) */
        handle: 'mild-hair-fall-recovery-kit',
        addonHandle: 'mild-hair-fall-recovery-kit-anti-dandruff-shampoo'
      },
      2: {  /* Hair Fall & Thinning Recovery Kit  (product 8600831885485 / addon 8601103794349) */
        handle: 'hair-fall-thinning-recovery-kit',
        addonHandle: 'hair-fall-thinning-recovery-kit-anti-dandruff-shampoo'
      },
      3: {  /* Bald Spot Recovery Kit  (product 8601102811309 / addon 8601103859885) */
        handle: 'bald-spot-recovery-kit',
        addonHandle: 'bald-spot-recovery-kit-anti-dandruff-shampoo'
      },
      4: {  /* Extreme Hair Fall & Baldness Recovery Kit  (product 8600833360045 / addon 8601103958189) */
        handle: 'extreme-hair-fall-baldness-recovery-kit',
        addonHandle: 'extreme-hair-fall-baldness-recovery-kit-anti-dandruff-shampoo'
      }
    }
  };

  /* ─── STATE ─── */
  var Q = {
    name: '',
    phone: '',
    gender: null,
    stage: null,
    dandruff: null
  };

  /* ─── HELPERS ─── */
  function toast(msg, d) {
    var t = document.getElementById('hqToast');
    t.textContent = msg;
    t.classList.add('show');
    setTimeout(function () {
      t.classList.remove('show')
    }, d || 2800);
  }

  function show(id) {
    var el = document.getElementById(id);
    el.classList.remove('hidden');
    el.style.display = '';
  }

  function hide(id) {
    var el = document.getElementById(id);
    el.classList.add('hidden');
    el.style.display = 'none';
  }

  var __bcLast = 0;

  function setBreadcrumb(n) {
    var target = n * 20;
    var fill = document.querySelector('#panel' + n + ' .p1-bc-fill');
    if (!fill) {
      __bcLast = target;
      return;
    }
    var from = __bcLast;
    __bcLast = target;
    /* style the fill entirely from JS so it works even if the CSS asset is stale */
    fill.style.background = 'linear-gradient(90deg,rgb(45,106,79),rgb(82,183,136))';
    fill.style.borderRadius = '20px';
    fill.style.height = '100%';
    fill.style.setProperty('transition', 'none', 'important'); /* start point, no anim */
    fill.style.width = from + '%';
    void fill.offsetWidth; /* commit start point */
    setTimeout(function () {
      /* !important beats any theme rule like transition:none!important */
      fill.style.setProperty('transition', 'width .65s cubic-bezier(.65,0,.35,1)', 'important');
      fill.style.width = target + '%';
    }, 60);
  }

  function goPanel(n) {
    for (var i = 1; i <= 5; i++) {
      document.getElementById('panel' + i).classList.remove('active');
      document.getElementById('panel' + i).classList.add('hidden');
    }
    var p = document.getElementById('panel' + n);
    p.classList.remove('hidden');
    p.classList.add('active');
    var shell = document.getElementById('hqShell');
    if (n === 5) { shell.classList.add('hq-wide'); } else { shell.classList.remove('hq-wide'); }
    setBreadcrumb(n);
    document.getElementById('hqShell').scrollTop = 0;
    window.scrollTo({
      top: document.getElementById('hqShell').offsetTop,
      behavior: 'smooth'
    });
  }

  /* ─── BTN READY STATE FOR STEP 1 ─── */
  function checkReady() {
    var n = document.getElementById('iName').value.trim();
    var p = document.getElementById('iPhone').value.trim();
    var ready = (n.length > 0 && /^\d{10}$/.test(p));
    var btn = document.getElementById('btnStart');
    if (ready) btn.classList.add('ready');
    else btn.classList.remove('ready');
  }
  document.addEventListener('DOMContentLoaded', function () {
    requestAnimationFrame(function () {
      setBreadcrumb(1);
    });
    document.getElementById('iName').addEventListener('input', checkReady);
    document.getElementById('iPhone').addEventListener('input', checkReady);
    document.getElementById('iName').addEventListener('keydown', function (e) {
      if (e.key === 'Enter') document.getElementById('iPhone').focus();
    });
    document.getElementById('iPhone').addEventListener('keydown', function (e) {
      if (e.key === 'Enter') step1Next();
    });
    /* Dandruff option listeners — belt-and-suspenders alongside onclick */
    var yesEl = document.getElementById('scalpYes');
    var noEl = document.getElementById('scalpNo');
    if (yesEl) yesEl.addEventListener('click', function () {
      pickDandruff('yes');
    });
    if (noEl) noEl.addEventListener('click', function () {
      pickDandruff('no');
    });
  });

  /* ─── STEP 1 ─── */
  function step1Next() {
    var n = document.getElementById('iName').value.trim();
    var p = document.getElementById('iPhone').value.trim();
    var ok = true;
    document.getElementById('eN').classList.remove('show');
    document.getElementById('eP').classList.remove('show');
    document.getElementById('wrapName').classList.remove('err');
    document.getElementById('wrapPhone').classList.remove('err');
    if (!n) {
      document.getElementById('eN').classList.add('show');
      document.getElementById('wrapName').classList.add('err');
      ok = false;
    }
    if (!/^\d{10}$/.test(p)) {
      document.getElementById('eP').classList.add('show');
      document.getElementById('wrapPhone').classList.add('err');
      ok = false;
    }
    if (!ok) return;
    Q.name = n;
    Q.phone = p;
    syncShopifyForm(n, '+91' + p);
    goPanel(2);
  }

  /* ─── STEP 2 ─── */
  function pickGender(g) {
    Q.gender = g;
    document.getElementById('cardMen').classList.remove('sel');
    document.getElementById('cardWomen').classList.remove('sel');
    document.getElementById('card' + (g === 'men' ? 'Men' : 'Women')).classList.add('sel');
    var btn = document.getElementById('btnContinue2');
    if (btn) {
      btn.classList.add('ready');
      btn.style.cursor = 'pointer';
    }
  }

  /* ─── STEP 3 ─── */
  var kitNames = {
    1: {
      name: 'Mild Hair Fall Kit',
      img: '🧴'
    },
    2: {
      name: 'Hair Fall Kit',
      img: '💊'
    },
    3: {
      name: 'Bald Spots Kit',
      img: '💉'
    },
    4: {
      name: 'Severe Hair Loss Kit',
      img: '🔬'
    }
  };

  function pickStage(n, gender, el) {
    Q.stage = n;
    /* deselect all rows for this gender */
    var rows = document.querySelectorAll('#' + gender + 'Stages .stage-row');
    rows.forEach(function (r) {
      r.classList.remove('sel');
    });
    el.classList.add('sel');
    /* enable Continue */
    var btn = document.getElementById('btnContinue3');
    if (btn) btn.classList.add('ready');
  }

  function step2Next() {
    if (!Q.gender) {
      document.getElementById('btnContinue2').style.cursor = 'not-allowed';
      return;
    }
    var menEl = document.getElementById('menStages');
    var womenEl = document.getElementById('womenStages');
    if (Q.gender === 'men') {
      menEl.classList.remove('hidden');
      menEl.style.display = 'flex';
      womenEl.classList.add('hidden');
      womenEl.style.display = 'none';
      document.getElementById('stageGenderLabel') && (document.getElementById('stageGenderLabel').textContent =
        "Men's Hair Stages");
      document.querySelector('#stageGenderPill .stage-gender-pill-ico') && (document.querySelector(
        '#stageGenderPill .stage-gender-pill-ico').textContent = '🧔');
    } else {
      womenEl.classList.remove('hidden');
      womenEl.style.display = 'flex';
      menEl.classList.add('hidden');
      menEl.style.display = 'none';
      document.getElementById('stageGenderLabel') && (document.getElementById('stageGenderLabel').textContent =
        "Women's Hair Stages");
      document.querySelector('#stageGenderPill .stage-gender-pill-ico') && (document.querySelector(
        '#stageGenderPill .stage-gender-pill-ico').textContent = '👩');
    }
    /* swap each stage image to the correct gender src */
    document.querySelectorAll('.stage-icon-box img[data-men]').forEach(function (img) {
      var genderSrc = img.getAttribute('data-' + Q.gender);
      if (genderSrc) img.src = genderSrc;
    });
    Q.stage = null;
    document.querySelectorAll('.stage-row').forEach(function (c) {
      c.classList.remove('sel');
    });
    var btn = document.getElementById('btnContinue3');
    if (btn) btn.classList.remove('ready');
    goPanel(3);
  }

  function step3Next() {
    if (!Q.stage) {
      document.getElementById('btnContinue3').style.cursor = 'not-allowed';
      return;
    }
    goPanel(4);
  }

  /* ─── STEP 4 ─── */
  function pickDandruff(v) {
    Q.dandruff = v;
    var yes = document.getElementById('scalpYes');
    var no = document.getElementById('scalpNo');
    yes.classList.remove('sel-yes', 'sel-no');
    no.classList.remove('sel-yes', 'sel-no');
    if (v === 'yes') {
      yes.classList.add('sel-yes');
    } else {
      no.classList.add('sel-no');
    }
    var btn = document.getElementById('btnContinue4');
    if (btn) btn.classList.add('ready');
  }

  function step4Next() {
    if (Q.dandruff === null) {
      document.getElementById('btnContinue4').style.cursor = 'not-allowed';
      return;
    }
    renderKit5();
    goPanel(5);
  }

  /* ─── ADD TO CART ─────────────────────────────────────────────────────
     CFG.kits stores product HANDLES. Shopify's /cart/add.js needs a VARIANT
     id, so we fetch the product's own JSON from the same-origin endpoint
     /products/<handle>.js (no token, no API scope, can't be blocked), read
     its first available variant id, then add that. Resolved ids are cached.
  ──────────────────────────────────────────────────────────────────────── */
  var __variantCache = {};

  function resolveVariantId(handle) {
    if (__variantCache[handle]) {
      return Promise.resolve(__variantCache[handle]);
    }
    return fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('product not found for handle "' + handle + '" (HTTP ' + r.status + ')');
        return r.json();
      })
      .then(function (p) {
        /* prefer the first in-stock variant, else just the first variant */
        var variants = (p && p.variants) || [];
        var chosen = variants.filter(function (v) { return v.available; })[0] || variants[0];
        if (chosen && chosen.id) {
          __variantCache[handle] = chosen.id;
          return chosen.id;
        }
        console.error('[hairquiz] no variant on product', handle, '| product json:', p);
        return null;
      });
  }

  /* Lightweight on-page confirmation (no dependency on a theme toast element). */
  function showAddedToast() {
    var t = document.createElement('div');
    t.textContent = 'Added to cart ✓';
    t.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);' +
      'background:#1a3d2b;color:#fff;font-weight:700;font-size:14px;padding:11px 22px;' +
      'border-radius:24px;box-shadow:0 6px 24px rgba(0,0,0,.18);z-index:99999;';
    document.body.appendChild(t);
    setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 2600);
  }

  /* Open the theme's cart drawer in place (no navigation). First nudges the
     theme to refresh the cart, then clicks the header cart-drawer toggle.
     Returns true if a toggle was found and clicked. If your theme's toggle
     isn't in this list, add its selector to `selectors` below. */
  function openCartDrawer() {
    ['cart:refresh', 'cart:build', 'cart:updated', 'ajaxCart:afterCartLoad'].forEach(function (name) {
      try { document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: {} })); } catch (e) {}
    });
    var selectors = [
      '[data-cart-drawer-toggle]',
      '[data-drawer-toggle="cart"]',
      '[aria-controls="cart-drawer"]',
      '.js-drawer-open-cart',
      '#cart-icon-bubble',
      '.header__icon--cart',
      '.site-header__cart',
      '.cart-toggle',
      '[data-action="open-cart"]'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) { el.click(); return true; }
    }
    return false;
  }

  function addToCart(withDandruff, btn) {
    if (btn) btn.classList.add('loading');
    var kit = CFG.kits[Q.stage];
    var handle = withDandruff ? kit.addonHandle : kit.handle;
    var note = 'Hair Quiz | ' + Q.name + ' | +91' + Q.phone + ' | Gender:' + Q.gender +
      ' | Stage:' + Q.stage + ' | Dandruff:' + (Q.dandruff || '-') + ' | Shampoo:' + (withDandruff ? 'yes' : 'no');

    resolveVariantId(handle)
      .then(function (variantId) {
        if (!variantId) {
          if (btn) btn.classList.remove('loading');
          alert('Sorry, this item could not be added to the cart right now.');
          return;
        }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], note: note })
        })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (btn) btn.classList.remove('loading');
            if (d.items || d.id) {
              /* Stay on this page: open the cart drawer in place. If the
                 theme's drawer toggle can't be found, show a confirmation. */
              if (!openCartDrawer()) showAddedToast();
            } else {
              console.error('[hairquiz] add to cart failed. Handle:', handle,
                'Variant:', variantId, '| Shopify response:', d);
              alert('Sorry, this item could not be added to the cart. (' +
                (d && d.description ? d.description : 'unknown error') + ')');
            }
          });
      })
      .catch(function (e) {
        if (btn) btn.classList.remove('loading');
        console.error('[hairquiz] add to cart error:', e);
        alert('Sorry, this item could not be added to the cart right now.');
      });
  }

  /* ─── WHATSAPP ─── */
  function openWA() {
    window.open('https://wa.me/' + CFG.whatsapp + '?text=' + encodeURIComponent(CFG.waMsg), '_blank');
  }

  /* ════════════════════════════════════════════════════════════════════
     LEAD CAPTURE — Storefront customerCreate + honeypot  (Option 2)
     --------------------------------------------------------------------
     Fires the instant "Start Assessment" is clicked. Creates a REAL
     customer record in Shopify (visible in Customers even if the user
     never orders). No page reload, no reCAPTCHA token required.
     The honeypot field (#hp_website in the HTML) blocks the bulk of
     automated bot spam at zero cost to real users.

     SETUP (one time, in Shopify admin):
       Settings → Apps and sales channels → Develop apps → Create an app
       → Configure Storefront API scopes → enable "unauthenticated_write_customers"
       → Install app → copy the Storefront API access token into SF_TOKEN below.

     SF_DOMAIN must be your *.myshopify.com domain, NOT your live domain.
  ════════════════════════════════════════════════════════════════════ */
  var SF_TOKEN  = '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';
  var SF_DOMAIN = 'lakshmikrishnanaturals.myshopify.com';   /* the *.myshopify.com domain — NOT the live domain */
  var LEAD_EMAIL_DOMAIN = 'lakshmikrishnanaturals.com';      /* a domain you control (used to mint a lead email) */

  function syncShopifyForm(name, phone) {
    /* Honeypot: a bot fills the hidden field, a human can't → skip silently if filled. */
    var hp = document.getElementById('hp_website');
    if (hp && hp.value.trim() !== '') {
      console.log('[hairquiz] honeypot tripped — skipping (likely bot).');
      return;
    }

    var digits = String(phone).replace(/\D/g, '');          /* e.g. 919876543210 */
    var email  = 'lead_' + digits + '@' + LEAD_EMAIL_DOMAIN;

    var query = [
      'mutation($input: CustomerCreateInput!) {',
      '  customerCreate(input: $input) {',
      '    customer { id }',
      '    customerUserErrors { field message }',
      '  }',
      '}'
    ].join('\n');

    var variables = {
      input: {
        firstName: name,
        email: email,
        phone: '+' + digits,                                /* E.164: +91XXXXXXXXXX */
        password: 'Lead-' + digits + '-' + Math.random().toString(36).slice(2, 8),
        acceptsMarketing: true
      }
    };

    /* Fire-and-forget: quiz advances to Step 2 immediately regardless of result. */
    try {
      fetch('https://' + SF_DOMAIN + '/api/2024-10/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': SF_TOKEN
        },
        body: JSON.stringify({ query: query, variables: variables })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          var cc = res && res.data && res.data.customerCreate;
          if (cc && cc.customer && cc.customer.id) {
            console.log('[hairquiz] customer created:', cc.customer.id);
          } else {
            console.warn('[hairquiz] no record created:', (cc && cc.customerUserErrors) || res.errors || []);
          }
        })
        .catch(function (e) {
          console.error('[hairquiz] lead submit failed (quiz continues):', e);
        });
    } catch (e) {}

    /* Local backup so addToCart() / later steps can reuse it. */
    try {
      sessionStorage.setItem('hairQuizLead', JSON.stringify({ name: name, phone: phone }));
    } catch (e) {}
  }

  /* ─── PRODUCT IMAGE URLS ─── */
  var IMG_ROYAL_OIL = "https://cdn.shopify.com/s/files/1/0725/5251/3709/files/Roots_and_Royal_Hair_oil.png?v=1780554834";
  var IMG_GUMMIES   = "https://cdn.shopify.com/s/files/1/0725/5251/3709/files/Gummies.png?v=1780554834";
  var IMG_SHAMPOO   = "https://cdn.shopify.com/s/files/1/0725/5251/3709/files/Anti_hairfall_shampoo.png?v=1780554834";
  var IMG_SERUM     = "https://cdn.shopify.com/s/files/1/0725/5251/3709/files/Redensyl_serum.png?v=1780554834";
  var IMG_HAIRGRO   = "https://cdn.shopify.com/s/files/1/0725/5251/3709/files/Hairgro_Powder.png?v=1780554834";
  var IMG_DERMA     = "https://cdn.shopify.com/s/files/1/0725/5251/3709/files/Derma_roller.png?v=1780554834";
  var IMG_OIL       = "https://cdn.shopify.com/s/files/1/0725/5251/3709/files/32_Hair_oil.png?v=1780554834";

  /* Hero images (unchanged) */
  var IMG_HERO1 = "https://cdn.shopify.com/s/files/1/0725/5251/3709/files/stage_1_1.png?v=1780316120";
  var IMG_HERO2 = "https://cdn.shopify.com/s/files/1/0725/5251/3709/files/stage_2_1.png?v=1780316120";
  var IMG_HERO3 = "https://cdn.shopify.com/s/files/1/0725/5251/3709/files/stage_2_1.png?v=1780316120";
  var IMG_HERO4 = "https://cdn.shopify.com/s/files/1/0725/5251/3709/files/Stage_4_2.png?v=1780640367";

  var KIT5_DATA = {
    1: {
      label: `Stage 1 Recommendations`,
      name: `MILD HAIRFALL & THINNING (NO BALD SPOT)`,
      pline: `Royal Roots Hair Oil & Biotin Gummies for Hair Growth`,
      no: `<div class=\"k5-prod-card\"><div class=\"k5-prod-tick\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\"><path d=\"M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z\" fill=\"#2D6A4F\"/><path d=\"M13.3307 7.5L8.7474 12.0833L6.66406 10\" stroke=\"#D8F3DC\" stroke-width=\"1.25\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg></div><div class=\"k5-prod-img\"><img src=\"${IMG_ROYAL_OIL}\" style=\"max-width:100%;max-height:100%;object-fit:contain\"/></div><div class=\"k5-prod-name\">Royal Roots<br>Hair Oil</div></div><div class=\"k5-plus\">+</div><div class=\"k5-prod-card\"><div class=\"k5-prod-tick\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\"><path d=\"M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z\" fill=\"#2D6A4F\"/><path d=\"M13.3307 7.5L8.7474 12.0833L6.66406 10\" stroke=\"#D8F3DC\" stroke-width=\"1.25\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg></div><div class=\"k5-prod-img\"><img src=\"${IMG_GUMMIES}\" style=\"max-width:100%;max-height:100%;object-fit:contain\"/></div><div class=\"k5-prod-name\">Biotin Gummies<br>for Hair Growth </div></div>`,
      yes: `<div class=\"k5-prod-card\"><div class=\"k5-prod-tick\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\"><path d=\"M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z\" fill=\"#2D6A4F\"/><path d=\"M13.3307 7.5L8.7474 12.0833L6.66406 10\" stroke=\"#D8F3DC\" stroke-width=\"1.25\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg></div><div class=\"k5-prod-img\"><img src=\"${IMG_ROYAL_OIL}\" style=\"max-width:100%;max-height:100%;object-fit:contain\"/></div><div class=\"k5-prod-name\">Royal Roots<br>Hair Oil</div></div><div class=\"k5-plus\">+</div><div class=\"k5-prod-card\"><div class=\"k5-prod-tick\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\"><path d=\"M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z\" fill=\"#2D6A4F\"/><path d=\"M13.3307 7.5L8.7474 12.0833L6.66406 10\" stroke=\"#D8F3DC\" stroke-width=\"1.25\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg></div><div class=\"k5-prod-img\"><img src=\"${IMG_GUMMIES}\" style=\"max-width:100%;max-height:100%;object-fit:contain\"/></div><div class=\"k5-prod-name\">Biotin Gummies<br>for Hair Growth</div></div><div class=\"k5-plus\">+</div><div class=\"k5-prod-card k5-addon-card\"><div class=\"k5-addon-badge\">Add-on</div><div class=\"k5-prod-img\"><img src=\"${IMG_SHAMPOO}\" style=\"max-width:100%;max-height:100%;object-fit:contain\"/></div><div class=\"k5-prod-name\">Anti Dandruff<br>Shampoo</div></div>`
    },
    2: {
      label: `Stage 2 Recommendations`,
      name: `VISIBLE BALD SPOT (NO HAIRFALL)`,
      pline: `Redensyl Advanced Hair Growth Serum, Hairgro Nutrition Mix Powder, Derma Roller`,
      no: `<div class="k5-prod-card"><div class="k5-prod-tick"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z" fill="#2D6A4F"/><path d="M13.3307 7.5L8.7474 12.0833L6.66406 10" stroke="#D8F3DC" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg></div><div class="k5-prod-img"><img src="${IMG_SERUM}" style="max-width:100%;max-height:100%;object-fit:contain"/></div><div class="k5-prod-name" style="color:#1a1a1a">Redensyl Advanced<br>Hair Growth Serum</div></div><div class="k5-plus">+</div><div class="k5-prod-card"><div class="k5-prod-tick"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z" fill="#2D6A4F"/><path d="M13.3307 7.5L8.7474 12.0833L6.66406 10" stroke="#D8F3DC" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg></div><div class="k5-prod-img"><img src="${IMG_HAIRGRO}" style="max-width:100%;max-height:100%;object-fit:contain"/></div><div class="k5-prod-name" style="color:#1a1a1a">Hairgro Nutrition<br>Mix Powder</div></div><div class="k5-plus">+</div><div class="k5-prod-card"><div class="k5-prod-tick"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z" fill="#2D6A4F"/><path d="M13.3307 7.5L8.7474 12.0833L6.66406 10" stroke="#D8F3DC" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg></div><div class="k5-prod-img"><img src="${IMG_DERMA}" style="max-width:100%;max-height:100%;object-fit:contain"/></div><div class="k5-prod-name" style="color:#1a1a1a">Derma Roller</div></div>`,
      yes: `<div class="k5-prod-card"><div class="k5-prod-tick"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z" fill="#2D6A4F"/><path d="M13.3307 7.5L8.7474 12.0833L6.66406 10" stroke="#D8F3DC" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg></div><div class="k5-prod-img"><img src="${IMG_SERUM}" style="max-width:100%;max-height:100%;object-fit:contain"/></div><div class="k5-prod-name" style="color:#1a1a1a">Redensyl Advanced<br>Hair Growth Serum</div></div><div class="k5-plus">+</div><div class="k5-prod-card"><div class="k5-prod-tick"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z" fill="#2D6A4F"/><path d="M13.3307 7.5L8.7474 12.0833L6.66406 10" stroke="#D8F3DC" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg></div><div class="k5-prod-img"><img src="${IMG_HAIRGRO}" style="max-width:100%;max-height:100%;object-fit:contain"/></div><div class="k5-prod-name" style="color:#1a1a1a">Hairgro Nutrition<br>Mix Powder</div></div><div class="k5-plus">+</div><div class="k5-prod-card"><div class="k5-prod-tick"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z" fill="#2D6A4F"/><path d="M13.3307 7.5L8.7474 12.0833L6.66406 10" stroke="#D8F3DC" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg></div><div class="k5-prod-img"><img src="${IMG_DERMA}" style="max-width:100%;max-height:100%;object-fit:contain"/></div><div class="k5-prod-name" style="color:#1a1a1a">Derma Roller</div></div><div class="k5-plus">+</div><div class="k5-prod-card  k5-addon-card"><div class="k5-addon-badge">Add-on</div><div class="k5-prod-img"><img src="${IMG_SHAMPOO}" style="max-width:100%;max-height:100%;object-fit:contain"/></div><div class="k5-prod-name" style="color:#E8920A">Anti Dandruff<br>Shampoo</div></div>`
    },
    3: {
      label: `Stage 3 Recommendations`,
      name: `MODERATE HAIRFALL & BALD SPOT`,
      pline: `Redensyl Advanced Hair Growth Serum, Royal Roots Hair Oil, Hairgro Nutrition Mix Powder, Derma Roller`,
      no: `<div class="k5-stack"><div class="k5-line"><div class="k5-prod-card"><div class="k5-prod-tick"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z" fill="#2D6A4F"/><path d="M13.3307 7.5L8.7474 12.0833L6.66406 10" stroke="#D8F3DC" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg></div><div class="k5-prod-img"><img src="${IMG_SERUM}" style="max-width:100%;max-height:100%;object-fit:contain"/></div><div class="k5-prod-name" style="color:#1a1a1a">Redensyl Advanced<br>Hair Growth Serum</div></div><div class="k5-plus">+</div><div class="k5-prod-card"><div class="k5-prod-tick"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z" fill="#2D6A4F"/><path d="M13.3307 7.5L8.7474 12.0833L6.66406 10" stroke="#D8F3DC" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg></div><div class="k5-prod-img"><img src="${IMG_ROYAL_OIL}" style="max-width:100%;max-height:100%;object-fit:contain"/></div><div class="k5-prod-name" style="color:#1a1a1a">Royal Roots<br>Hair Oil</div></div><div class="k5-plus">+</div><div class="k5-prod-card"><div class="k5-prod-tick"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z" fill="#2D6A4F"/><path d="M13.3307 7.5L8.7474 12.0833L6.66406 10" stroke="#D8F3DC" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg></div><div class="k5-prod-img"><img src="${IMG_HAIRGRO}" style="max-width:100%;max-height:100%;object-fit:contain"/></div><div class="k5-prod-name" style="color:#1a1a1a">Hairgro Nutrition<br>Mix Powder</div></div><div class="k5-plus">+</div><div class="k5-prod-card"><div class="k5-prod-tick"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z" fill="#2D6A4F"/><path d="M13.3307 7.5L8.7474 12.0833L6.66406 10" stroke="#D8F3DC" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg></div><div class="k5-prod-img"><img src="${IMG_DERMA}" style="max-width:100%;max-height:100%;object-fit:contain"/></div><div class="k5-prod-name" style="color:#1a1a1a">Derma Roller</div></div></div></div>`,
      yes: `<div class="k5-stack"><div class="k5-line"><div class="k5-prod-card"><div class="k5-prod-tick"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z" fill="#2D6A4F"/><path d="M13.3307 7.5L8.7474 12.0833L6.66406 10" stroke="#D8F3DC" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg></div><div class="k5-prod-img"><img src="${IMG_SERUM}" style="max-width:100%;max-height:100%;object-fit:contain"/></div><div class="k5-prod-name" style="color:#1a1a1a">Redensyl Advanced<br>Hair Growth Serum</div></div><div class="k5-plus">+</div><div class="k5-prod-card"><div class="k5-prod-tick"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z" fill="#2D6A4F"/><path d="M13.3307 7.5L8.7474 12.0833L6.66406 10" stroke="#D8F3DC" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg></div><div class="k5-prod-img"><img src="${IMG_ROYAL_OIL}" style="max-width:100%;max-height:100%;object-fit:contain"/></div><div class="k5-prod-name" style="color:#1a1a1a">Royal Roots<br>Hair Oil</div></div><div class="k5-plus">+</div><div class="k5-prod-card"><div class="k5-prod-tick"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z" fill="#2D6A4F"/><path d="M13.3307 7.5L8.7474 12.0833L6.66406 10" stroke="#D8F3DC" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg></div><div class="k5-prod-img"><img src="${IMG_HAIRGRO}" style="max-width:100%;max-height:100%;object-fit:contain"/></div><div class="k5-prod-name" style="color:#1a1a1a">Hairgro Nutrition<br>Mix Powder</div></div><div class="k5-plus">+</div><div class="k5-prod-card"><div class="k5-prod-tick"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z" fill="#2D6A4F"/><path d="M13.3307 7.5L8.7474 12.0833L6.66406 10" stroke="#D8F3DC" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg></div><div class="k5-prod-img"><img src="${IMG_DERMA}" style="max-width:100%;max-height:100%;object-fit:contain"/></div><div class="k5-prod-name" style="color:#1a1a1a">Derma Roller</div></div><div class="k5-plus">+</div><div class="k5-prod-card k5-addon-card"><div class="k5-addon-badge">Add-on</div><div class="k5-prod-img"><img src="${IMG_SHAMPOO}" style="max-width:100%;max-height:100%;object-fit:contain"/></div><div class="k5-prod-name" style="color:#E8920A">Anti Dandruff<br>Shampoo</div></div></div></div>`
    },
    4: {
      label: `Stage 4 Recommendations`,
      name: `EXTREME HAIRFALL & BALD SPOT`,
      pline: `Redensyl Advanced Hair Growth Serum, Royal Roots Hair Oil, Hairgro Nutrition Mix Powder, Derma Roller`,
      no: `<div class="k5-stack"><div class="k5-line"><div class="k5-prod-card"><div class="k5-prod-tick"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z" fill="#2D6A4F"/><path d="M13.3307 7.5L8.7474 12.0833L6.66406 10" stroke="#D8F3DC" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg></div><div class="k5-prod-img"><img src="${IMG_SERUM}" style="max-width:100%;max-height:100%;object-fit:contain"/></div><div class="k5-prod-name" style="color:#1a1a1a">Redensyl Advanced<br>Hair Growth Serum</div></div><div class="k5-plus">+</div><div class="k5-prod-card"><div class="k5-prod-tick"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z" fill="#2D6A4F"/><path d="M13.3307 7.5L8.7474 12.0833L6.66406 10" stroke="#D8F3DC" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg></div><div class="k5-prod-img"><img src="${IMG_ROYAL_OIL}" style="max-width:100%;max-height:100%;object-fit:contain"/></div><div class="k5-prod-name" style="color:#1a1a1a">Royal Roots<br>Hair Oil</div></div><div class="k5-plus">+</div><div class="k5-prod-card"><div class="k5-prod-tick"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z" fill="#2D6A4F"/><path d="M13.3307 7.5L8.7474 12.0833L6.66406 10" stroke="#D8F3DC" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg></div><div class="k5-prod-img"><img src="${IMG_HAIRGRO}" style="max-width:100%;max-height:100%;object-fit:contain"/></div><div class="k5-prod-name" style="color:#1a1a1a">Hairgro Nutrition<br>Mix Powder</div></div><div class="k5-plus">+</div><div class="k5-prod-card"><div class="k5-prod-tick"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z" fill="#2D6A4F"/><path d="M13.3307 7.5L8.7474 12.0833L6.66406 10" stroke="#D8F3DC" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg></div><div class="k5-prod-img"><img src="${IMG_DERMA}" style="max-width:100%;max-height:100%;object-fit:contain"/></div><div class="k5-prod-name" style="color:#1a1a1a">Derma Roller</div></div></div></div>`,
      yes: `<div class="k5-stack"><div class="k5-line"><div class="k5-prod-card"><div class="k5-prod-tick"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z" fill="#2D6A4F"/><path d="M13.3307 7.5L8.7474 12.0833L6.66406 10" stroke="#D8F3DC" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg></div><div class="k5-prod-img"><img src="${IMG_SERUM}" style="max-width:100%;max-height:100%;object-fit:contain"/></div><div class="k5-prod-name" style="color:#1a1a1a">Redensyl Advanced<br>Hair Growth Serum</div></div><div class="k5-plus">+</div><div class="k5-prod-card"><div class="k5-prod-tick"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z" fill="#2D6A4F"/><path d="M13.3307 7.5L8.7474 12.0833L6.66406 10" stroke="#D8F3DC" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg></div><div class="k5-prod-img"><img src="${IMG_ROYAL_OIL}" style="max-width:100%;max-height:100%;object-fit:contain"/></div><div class="k5-prod-name" style="color:#1a1a1a">Royal Roots<br>Hair Oil</div></div><div class="k5-plus">+</div><div class="k5-prod-card"><div class="k5-prod-tick"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z" fill="#2D6A4F"/><path d="M13.3307 7.5L8.7474 12.0833L6.66406 10" stroke="#D8F3DC" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg></div><div class="k5-prod-img"><img src="${IMG_HAIRGRO}" style="max-width:100%;max-height:100%;object-fit:contain"/></div><div class="k5-prod-name" style="color:#1a1a1a">Hairgro Nutrition<br>Mix Powder</div></div><div class="k5-plus">+</div><div class="k5-prod-card"><div class="k5-prod-tick"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z" fill="#2D6A4F"/><path d="M13.3307 7.5L8.7474 12.0833L6.66406 10" stroke="#D8F3DC" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg></div><div class="k5-prod-img"><img src="${IMG_DERMA}" style="max-width:100%;max-height:100%;object-fit:contain"/></div><div class="k5-prod-name" style="color:#1a1a1a">Derma Roller</div></div><div class="k5-plus">+</div><div class="k5-prod-card k5-addon-card"><div class="k5-addon-badge">Add-on</div><div class="k5-prod-img"><img src="${IMG_SHAMPOO}" style="max-width:100%;max-height:100%;object-fit:contain"/></div><div class="k5-prod-name" style="color:#E8920A">Anti Dandruff<br>Shampoo</div></div></div></div>`
    },
  };
  var KIT5_HERO = {
    1: `<img src="${IMG_HERO1}" style="width:100%;height:auto;display:block;object-fit:contain"/>`,
    2: `<img src="${IMG_HERO2}" style="width:100%;height:auto;display:block;object-fit:contain"/>`,
    3: `<img src="${IMG_HERO4}" style="width:100%;height:auto;display:block;object-fit:contain"/>`,
    4: `<img src="${IMG_HERO4}" style="width:100%;height:auto;display:block;object-fit:contain"/>`,
  };

  /* ════════════════════════════════════════════════════════════════════
     KIT ACCORDION DATA — Key Ingredients & Product Benefits
     ════════════════════════════════════════════════════════════════════ */
  var SHAMPOO_INGREDIENTS = ['Aloe Vera', 'Hibiscus', 'Avarampoo', 'Farm Fresh Goat Milk'];
  var SHAMPOO_BENEFITS = [
    {
      title: 'Anti Dandruff Shampoo',
      desc: 'Anti dandruff shampoo contains nutrient rich herbs which help to reduce dandruff and itchy scalp.'
    },
    {
      title: 'Reduce Dandruff and Control Oil',
      desc: 'The vitamin C present in black pepper can help you in cleaning your scalp and getting rid of dead skin cells from the scalp and balance oil level on the scalp.'
    },
    {
      title: 'Anti Microbial Properties',
      desc: 'Kadukai has its own anti microbial properties it helps to treat all the scalp infections. Kadukkai is good for promoting hair growth, controlling hair loss, treating lice, treating dandruff problems, preventing grey hair (white hair) and maintaining the natural color of your hair.'
    },
    {
      title: 'Nourishes the Hair',
      desc: 'Rich in protein and fatty acid that provides natural shine to the hair. Goat milk helps to nourish the frizzy hair and improve scalp and hair health.'
    }
  ];

  /* ─── STAGE 1 — Mild Hair Fall Recovery Kit ─── */
  var KIT1_INGREDIENTS = [
    'Hibiscus', 'Amla', 'Curry leaves', 'Aloe vera',
    'Vitamin A, C', 'Biotin', 'Zinc', 'Vitamin E', 'Vitamin B'
  ];
  var KIT1_BENEFITS = [
    {
      title: 'Encourages healthy hair growth cycle',
      desc: 'Supports healthy hair growth by nourishing follicles and helping maintain a natural growth cycle.'
    },
    {
      title: 'Helps minimize breakage and hair fall',
      desc: 'Helps reduce hair fall and breakage, keeping your hair looking fuller and stronger.'
    },
    {
      title: 'Strengthens weak roots from within',
      desc: 'Strengthens hair roots from within, improving hair resilience and reducing weakness over time.'
    },
    {
      title: 'Maintains a clean, nourished scalp',
      desc: 'Keeps your scalp healthy by cleansing impurities and providing essential nourishment and hydration.'
    },
    {
      title: 'Reduces Hair Fall',
      desc: 'Targets hair root cells and strengthens follicles → less breakage & shedding.'
    },
    {
      title: 'Boosts New Hair Growth',
      desc: 'Activates dormant hair follicles to start new hair growth cycle.'
    },
    {
      title: 'Increases Hair Density',
      desc: 'More active follicles = thicker looking hair over time.'
    },
    {
      title: 'Strengthens Hair Roots',
      desc: 'Improves anchoring of hair strands in scalp.'
    }
  ];

  /* ─── STAGE 2 — Hair Fall & Thinning Recovery Kit ─── */
  var KIT2_INGREDIENTS = [
    'Redensyl 3%', 'Anagain 4%', 'Procapil', 'Sodium Gluconate',
    'Biotin', 'Heptyl Glucoside', 'Caffeine', 'Keratin',
    'Amla', 'Fenugreek', 'Vitamin C'
  ];
  var KIT2_BENEFITS = [
    {
      title: 'Reduces Hair Fall',
      desc: 'Targets hair root cells and strengthens follicles → less breakage & shedding.'
    },
    {
      title: 'Boosts New Hair Growth',
      desc: 'Activates dormant hair follicles to start new hair growth cycle.'
    },
    {
      title: 'Increases Hair Density',
      desc: 'More active follicles = thicker looking hair over time.'
    },
    {
      title: 'Strengthens Hair Roots',
      desc: 'Improves anchoring of hair strands in scalp.'
    },
    {
      title: 'Reduces hair fall from root cause (nutrient deficiency)',
      desc: 'Helps reduce hair fall by giving your body the nutrients it needs.'
    },
    {
      title: 'Supports new hair growth & thickness',
      desc: 'Helps new hair grow and makes your hair look fuller.'
    },
    {
      title: 'Strengthens hair roots (follicle nourishment)',
      desc: 'Makes your hair roots stronger so your hair doesn\u2019t fall easily.'
    },
    {
      title: 'Improves overall scalp health',
      desc: 'Keeps your scalp healthy, which is important for good hair growth.'
    },
    {
      title: 'Adds natural shine & smoothness',
      desc: 'Makes your hair look smooth, soft, and naturally shiny.'
    },
    {
      title: 'Helps reduce hair thinning & breakage',
      desc: 'Helps reduce thin hair and prevents hair from breaking easily.'
    },
    {
      title: 'Healthy Hair',
      desc: 'Contains Multivitamins that are necessary for good hair growth.'
    },
    {
      title: 'Quick Growth',
      desc: 'It will give instant results as Hair will grow rapidly in the first month itself.'
    },
    {
      title: 'Thickening Progress',
      desc: 'Hair thickness will improve from the first month.'
    },
    {
      title: 'Root Revival',
      desc: 'Redensyl hair growth serum strengthens hair roots and reduces hair loss by nourishing the scalp.'
    },
    {
      title: 'Damage Defense',
      desc: 'Protects Against Environmental Damage.'
    },
    {
      title: 'Frizz Control',
      desc: 'Reduces Frizz.'
    }
  ];

  /* ─── STAGE 4 — Extreme Hair Fall & Baldness Recovery Kit ─── */
  var KIT4_INGREDIENTS = [
    'Redensyl 3%', 'Anagain 4%', 'Procapil', 'Sodium Gluconate',
    'Biotin', 'Heptyl Glucoside', 'Caffeine',
    'Hibiscus', 'Amla', 'Curry leaves', 'Aloe vera'
  ];
  var KIT4_BENEFITS = [
    {
      title: 'Encourages healthy hair growth cycle',
      desc: 'Supports healthy hair growth by nourishing follicles and helping maintain a natural growth cycle.'
    },
    {
      title: 'Helps minimize breakage and hair fall',
      desc: 'Helps reduce hair fall and breakage, keeping your hair looking fuller and stronger.'
    },
    {
      title: 'Strengthens weak roots from within',
      desc: 'Strengthens hair roots from within, improving hair resilience and reducing weakness over time.'
    },
    {
      title: 'Maintains a clean, nourished scalp',
      desc: 'Keeps your scalp healthy by cleansing impurities and providing essential nourishment and hydration.'
    },
    {
      title: 'Reduces hair fall from root cause (nutrient deficiency)',
      desc: 'Helps reduce hair fall by giving your body the nutrients it needs.'
    },
    {
      title: 'Supports new hair growth & thickness',
      desc: 'Helps new hair grow and makes your hair look fuller.'
    },
    {
      title: 'Strengthens hair roots (follicle nourishment)',
      desc: 'Makes your hair roots stronger so your hair doesn\u2019t fall easily.'
    },
    {
      title: 'Improves overall scalp health',
      desc: 'Keeps your scalp healthy, which is important for good hair growth.'
    },
    {
      title: 'Adds natural shine & smoothness',
      desc: 'Makes your hair look smooth, soft, and naturally shiny.'
    },
    {
      title: 'Helps reduce hair thinning & breakage',
      desc: 'Helps reduce thin hair and prevents hair from breaking easily.'
    }
  ];

  var KIT5_ACCORDION = {
    1: { ingredients: KIT1_INGREDIENTS, benefits: KIT1_BENEFITS },   /* Mild Hair Fall Recovery Kit */
    2: { ingredients: KIT2_INGREDIENTS, benefits: KIT2_BENEFITS },   /* Hair Fall & Thinning Recovery Kit */
    3: { ingredients: KIT4_INGREDIENTS, benefits: KIT4_BENEFITS },   /* Bald Spot Recovery Kit — same content as combo 4 */
    4: { ingredients: KIT4_INGREDIENTS, benefits: KIT4_BENEFITS }    /* Extreme Hair Fall & Baldness Recovery Kit */
  };

  var LEAF_URL = 'https://cdn.shopify.com/s/files/1/0725/5251/3709/files/Frame_2087326627.png?v=1780495229';

  var ICON_PLUS  = '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M3.4 9.53922V-0.000781536H5.64V9.53922H3.4ZM1.49012e-08 5.85922V3.69922H9.02V5.85922H1.49012e-08Z" fill="black"/></svg>';
  var ICON_MINUS = '<svg xmlns="http://www.w3.org/2000/svg" width="8" height="3" viewBox="0 0 8 3" fill="none"><path d="M0.000781298 2.40062V0.000624657H7.32078V2.40062H0.000781298Z" fill="black"/></svg>';
  var CHECK_SVG  = '<svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none"><path d="M9 2.5L4.4 8L2 5.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function buildAccordionHTML(ingredients, benefits) {
    var ingPills = ingredients.map(function (ing) {
      return '<span class="k5-ing-pill">' + ing + '</span>';
    }).join('');

    var benItems = benefits.map(function (b) {
      return '<div class="k5-benefit-item">'
        + '<div class="k5-benefit-dot">' + CHECK_SVG + '</div>'
        + '<div class="k5-benefit-text">'
        + '<div class="k5-benefit-title">' + b.title + '</div>'
        + (b.desc ? '<div class="k5-benefit-desc">' + b.desc + '</div>' : '')
        + '</div>'
        + '</div>';
    }).join('');

    var ingCard =
      '<div class="k5-acc-card" id="accIngCard">'
        + '<div class="k5-acc-header" onclick="toggleAcc(\'accIngCard\')">'
          + '<div class="k5-acc-header-left">'
            + '<img class="k5-acc-leaf" src="' + LEAF_URL + '" alt="" aria-hidden="true">'
            + '<span class="k5-acc-title">Key ingredients</span>'
          + '</div>'
          + '<span class="k5-acc-icon">' + ICON_PLUS + '</span>'
        + '</div>'
        + '<div class="k5-acc-body">'
          + '<div class="k5-acc-body-inner">'
            + '<div class="k5-ing-grid">' + ingPills + '</div>'
          + '</div>'
        + '</div>'
      + '</div>';

    var benCard =
      '<div class="k5-acc-card" id="accBenCard">'
        + '<div class="k5-acc-header" onclick="toggleAcc(\'accBenCard\')">'
          + '<div class="k5-acc-header-left">'
            + '<img class="k5-acc-leaf" src="' + LEAF_URL + '" alt="" aria-hidden="true">'
            + '<span class="k5-acc-title">Product Benefits</span>'
          + '</div>'
          + '<span class="k5-acc-icon">' + ICON_PLUS + '</span>'
        + '</div>'
        + '<div class="k5-acc-body">'
          + '<div class="k5-acc-body-inner">'
            + '<div class="k5-benefits-list">' + benItems + '</div>'
          + '</div>'
        + '</div>'
      + '</div>';

    return ingCard + benCard;
  }

  /* Opens the clicked accordion and closes all others (one open at a time). */
  function toggleAcc(cardId) {
    var card = document.getElementById(cardId);
    if (!card) return;
    var isOpen = card.classList.contains('open');

    document.querySelectorAll('.k5-acc-card').forEach(function (c) {
      c.classList.remove('open');
      var icon = c.querySelector('.k5-acc-icon');
      if (icon) icon.innerHTML = ICON_PLUS;
    });

    if (!isOpen) {
      card.classList.add('open');
      var icon = card.querySelector('.k5-acc-icon');
      if (icon) icon.innerHTML = ICON_MINUS;
    }
  }

  function renderKit5() {
    var s = Q.stage || 3;
    var d = Q.dandruff === 'yes';
    var kit = KIT5_DATA[s];
    if (!kit) return;
    document.getElementById('k5Label').textContent = kit.label;
    document.getElementById('k5Name').textContent = kit.name;
    document.getElementById('k5Pline').textContent = kit.pline;
    document.getElementById('k5HeroImgs').innerHTML = KIT5_HERO[s] || '';
    var k5row = document.getElementById('k5ProductsRow');
    k5row.innerHTML = d ? kit.yes : kit.no;
    k5row.classList.toggle('cols4', k5row.querySelectorAll('.k5-prod-card').length >= 4);

    /* ── Accordion: Key Ingredients + Product Benefits ──
       When dandruff = 'yes', the Anti Dandruff Shampoo's ingredients and
       benefits are appended to the kit's own. ── */
    var accWrap = document.getElementById('k5AccordionWrap');
    if (accWrap) {
      var accData = KIT5_ACCORDION[s];
      if (accData) {
        var ingredients = accData.ingredients.slice();
        var benefits = accData.benefits.slice();
        if (d) {
          /* append shampoo content, skipping any ingredient already listed */
          SHAMPOO_INGREDIENTS.forEach(function (ing) {
            var exists = ingredients.some(function (x) {
              return x.toLowerCase() === ing.toLowerCase();
            });
            if (!exists) ingredients.push(ing);
          });
          benefits = benefits.concat(SHAMPOO_BENEFITS);
        }
        accWrap.innerHTML = buildAccordionHTML(ingredients, benefits);
      } else {
        /* No accordion content for this stage yet → render nothing. */
        accWrap.innerHTML = '';
      }
    }

    (function () {
      document.querySelectorAll('body > .k5-addon-tip').forEach(function (t) {
        t.remove();
      });
      var SVG =
        '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><rect x="0.5" y="0.5" width="13" height="13" rx="6.5" stroke="white"/><path d="M6.36239 11.5V4.95455H7.63654V11.5H6.36239ZM7.00586 3.9446C6.78427 3.9446 6.59393 3.87074 6.43484 3.72301C6.27859 3.57244 6.20046 3.39347 6.20046 3.18608C6.20046 2.97585 6.27859 2.79687 6.43484 2.64915C6.59393 2.49858 6.78427 2.4233 7.00586 2.4233C7.22745 2.4233 7.41637 2.49858 7.57262 2.64915C7.73171 2.79787 7.81126 2.97585 7.81126 3.18608C7.81126 3.39347 7.73171 3.57244 7.57262 3.72301C7.41637 3.87074 7.22745 3.9446 7.00586 3.9446Z" fill="white"/></svg>';
      var MSG = 'Highly recommended because you have dandruff or itchy scalp';
      k5row.querySelectorAll('.k5-addon-badge').forEach(function (badge) {
        badge.innerHTML =
          '<span class="k5-addon-badge-txt">Add-on</span>' +
          '<button type="button" class="k5-addon-i" aria-label="Why is this added?">' + SVG + '</button>';
        /* tooltip lives on <body> so no parent overflow can clip it */
        var tip = document.createElement('div');
        tip.className = 'k5-addon-tip';
        tip.textContent = MSG;
        document.body.appendChild(tip);

        function show() {
          var br = badge.getBoundingClientRect();
          var tw = tip.offsetWidth,
            th = tip.offsetHeight;
          var cx = br.left + br.width / 2;
          var left = Math.max(8, Math.min(cx - tw / 2, window.innerWidth - tw - 8));
          var top = br.top - th - 10;
          tip.style.left = left + 'px';
          tip.style.top = top + 'px';
          tip.style.setProperty('--arrow-left', (cx - left) + 'px');
          tip.classList.add('show');
        }

        function hide() {
          tip.classList.remove('show');
        }
        badge.addEventListener('mouseenter', show);
        badge.addEventListener('mouseleave', hide);
        badge.addEventListener('focusin', show);
        badge.addEventListener('focusout', hide);
        /* Mobile: tap toggles the tip (so it can be dismissed); stopPropagation
           keeps the document handler below from immediately closing it. */
        badge.addEventListener('touchstart', function (e) {
          e.stopPropagation();
          if (tip.classList.contains('show')) { hide(); } else { show(); }
        }, { passive: true });
      });
      /* Tap anywhere outside an open tip closes it (added once for the page). */
      if (!window.__k5TipDismiss) {
        window.__k5TipDismiss = true;
        var closeAllTips = function () {
          document.querySelectorAll('body > .k5-addon-tip.show').forEach(function (t) {
            t.classList.remove('show');
          });
        };
        document.addEventListener('touchstart', closeAllTips, { passive: true });
        window.addEventListener('scroll', closeAllTips, { passive: true });
      }
    })();
    var orderHost = document.getElementById('k5OrderBtns');
    if (orderHost) {
      var cartSvg = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>';
      var mkBtn = function (addon, extraCls) {
        return '<button class="k5-btn-order ' + extraCls + '" onclick="addToCart(' + (addon ? 'true' : 'false') + ',this)">'
          + '<span class="k5-btn-top">' + cartSvg + '<span class="k5-btn-main">ORDER NOW</span></span>'
          + '<span class="k5-btn-sub">' + kit.name + (addon ? ' + Anti Dandruff Shampoo' : '') + '</span>'
          + '<span class="spin"></span></button>';
      };
      orderHost.innerHTML = (Q.dandruff === 'yes')
        ? (mkBtn(false, '') + mkBtn(true, 'k5-btn-order-addon'))
        : mkBtn(false, '');
    }
  }

 /* ==========================================================================
   PANEL 5 MARQUEE SCROLLER

   iOS fix: the track used CSS `width: max-content` + a transform animation,
   and Panel 5 starts as display:none. iOS Safari does NOT recompute a
   max-content flex track when it goes from display:none -> visible, so on
   reveal the track keeps a zero width, gets clipped by overflow:hidden, and
   the images never show (works fine on Chrome/Android, which recompute).

   We therefore (1) clone the slides once, then (2) MEASURE the slides and set
   an explicit PIXEL width on the track — but only once the marquee is actually
   visible (IntersectionObserver) — and restart the animation so iOS repaints.
   Explicit px width removes all dependence on max-content. The keyframe still
   uses translateX(-50%): with width = 2x one slide-set, -50% = exactly one
   set, so the loop stays seamless.
   ========================================================================== */
(function () {
  var track = document.getElementById('scrollerTrack');
  if (!track) return;

  var SECONDS_PER_SLIDE = 6;
  var originalCount = 0;
  var didClone = false;
  var lastTotal = 0;

  function cloneOnce() {
    if (didClone) return;
    var slides = track.querySelectorAll('.scroller-slide');
    if (!slides.length) return;
    originalCount = slides.length;
    slides.forEach(function (slide) {
      var clone = slide.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });
    didClone = true;
  }

  /* Measure while visible and lock in an explicit pixel width. */
  function layout() {
    if (!didClone) return;
    var slides = track.querySelectorAll('.scroller-slide');
    if (!slides.length) return;

    var singleSet = 0;
    for (var i = 0; i < originalCount; i++) {
      singleSet += slides[i].getBoundingClientRect().width;
    }
    if (singleSet <= 0) return;                 /* still hidden / not laid out */

    var total = Math.round(singleSet * 2);      /* original set + clone set */
    if (total === lastTotal) return;            /* unchanged: don't restart anim */
    lastTotal = total;

    track.style.width = total + 'px';
    /* Restart the animation so iOS repaints with the new width — but do it via
       the animation-NAME longhand only. Using the `animation` shorthand would
       also write an inline `animation-play-state: running`, which beats the CSS
       `.scroller-wrapper:hover { animation-play-state: paused }` rule and breaks
       hover-pause on desktop. Touching only name + duration leaves play-state
       under the stylesheet's control (CSS hover pause / mobile touch handlers). */
    track.style.animationName = 'none';
    void track.offsetWidth;                     /* force reflow */
    track.style.animationName = 'scrollLeft';
    track.style.animationDuration = (SECONDS_PER_SLIDE * originalCount) + 's';
    track.style.animationTimingFunction = 'linear';
    track.style.animationIterationCount = 'infinite';
  }

  function ensure() {
    cloneOnce();
    layout();
  }

  /* Run when the marquee first becomes visible (Panel 5 is hidden until step 5). */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          ensure();
          requestAnimationFrame(layout);        /* second pass once layout settles */
        }
      });
    }, { threshold: 0.01 });
    io.observe(track);
  }

  /* Fallbacks (harmless if already done): DOM ready + full load. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensure);
  } else {
    ensure();
  }
  window.addEventListener('load', ensure);

  /* Slide width is responsive — re-measure on resize / orientation change. */
  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(layout, 200);
  }, { passive: true });

  /* Pause while a finger is touching the marquee; resume on release.
     setProperty(...,'important') is REQUIRED: the theme CSS sets play-state
     with !important, so a plain inline style is ignored. touchend/touchcancel
     listen on `document` so a release that drifts outside still resumes. */
  function pauseMarquee() {
    track.style.setProperty('animation-play-state', 'paused', 'important');
  }
  function resumeMarquee() {
    track.style.setProperty('animation-play-state', 'running', 'important');
  }
  track.addEventListener('touchstart', pauseMarquee, { passive: true });
  document.addEventListener('touchend', resumeMarquee, { passive: true });
  document.addEventListener('touchcancel', resumeMarquee, { passive: true });
})();